module.exports = "/_next/static/images/347ae664e28d13d67aa506d7428dbe3e-device-frame@3x.png.webp";